export default "__VITE_ASSET__BX16VAFi__"